import React from 'react';


const Trabajos = () => (
    <section className="trabajos seccionMargenInferior" id="trabajos">
        <h2 className="tituloDeSeccion trabajos__titulo--seccion">Trabajos Realizados</h2>
        <div className="container trabajos__container">
            <figure className="trabajos__item">
                <img src="../img/trabajos_realizados/1.jpg" className="trabajos__imagen" alt="imagen 1" />
                <figcaption className="trabajos__item--trasera">
                    <h2 className="titulo">Sipro</h2>
                    <h3 className="subtitulo">Empresa de desarrollo de productos de higiene institucional</h3>
                    <a className="vermas" href="http://sipro.com.ar/" target={'_blank'} rel={'noopener noreferrer'}>Más Información</a>
                </figcaption>
            </figure>
            <figure className="trabajos__item">
                <img src="../img/trabajos_realizados/1.jpg" className="trabajos__imagen" alt="imagen 1" />
                <figcaption className="trabajos__item--trasera">
                    <h2 className="titulo">Tarot Reiki Astral</h2>
                    <h3 className="subtitulo">Sitio de espiritualidad y astrología</h3>
                    <a className="vermas" href="http://tarotreikiastral.com.ar/" target={'_blank'} rel={'noopener noreferrer'}>Más Información</a>
                </figcaption>
            </figure>
            <figure className="trabajos__item">
                <img src="../img/trabajos_realizados/1.jpg" className="trabajos__imagen" alt="imagen 1" />
                <figcaption className="trabajos__item--trasera">
                    <h2 className="titulo">Christian Peralta</h2>
                    <h3 className="subtitulo">Página web personal de desarrollador web</h3>
                    <a className="vermas" href="http://christianperalta.com/" target={'_blank'} rel={'noopener noreferrer'}>Más Información</a>
                </figcaption>
            </figure>
            <figure className="trabajos__item">
                <img src="../img/trabajos_realizados/1.jpg" className="trabajos__imagen" alt="imagen 1" />
                <figcaption className="trabajos__item--trasera">
                    <h2 className="titulo">No Violencia BA</h2>
                    <h3 className="subtitulo">Institución que difunde los ideales de paz</h3>
                    <a className="vermas" href="http://noviolenciabuenosaires.christianperalta.com/" target={'_blank'} rel={'noopener noreferrer'}>Más Información</a>
                </figcaption>
            </figure>
            <figure className="trabajos__item">
                <img src="../img/trabajos_realizados/1.jpg" className="trabajos__imagen" alt="imagen 1" />
                <figcaption className="trabajos__item--trasera">
                    <h2 className="titulo">DanFra</h2>
                    <h3 className="subtitulo">Empresa de servicios de electricidad y afines</h3>
                    <a className="vermas" href="http://danfra.com.ar/" target={'_blank'} rel={'noopener noreferrer'}>Más Información</a>
                </figcaption>
            </figure>
            <figure className="trabajos__item">
                <img src="../img/trabajos_realizados/1.jpg" className="trabajos__imagen" alt="imagen 1" />
                <figcaption className="trabajos__item--trasera">
                    <h2 className="titulo">Pino Software</h2>
                    <h3 className="subtitulo">Empresa de desarrollo orientada a soluciones globales de software</h3>
                    <a className="vermas" href="http://pinosoft.com.ar/" target={'_blank'} rel={'noopener noreferrer'}>Más Información</a>
                </figcaption>
            </figure>
            <figure className="trabajos__item">
                <img src="../img/trabajos_realizados/1.jpg" className="trabajos__imagen" alt="imagen 1" />
                <figcaption className="trabajos__item--trasera">
                    <h2 className="titulo">RPS Consultora</h2>
                    <h3 className="subtitulo">Estudio Profesional de Contadores</h3>
                    <a className="vermas" href="http://rpsconsultora.com.ar/" target={'_blank'} rel={'noopener noreferrer'}>Más Información</a>
                </figcaption>
            </figure>
            <figure className="trabajos__item">
                <img src="../img/trabajos_realizados/1.jpg" className="trabajos__imagen" alt="imagen 1" />
                <figcaption className="trabajos__item--trasera">
                    <h2 className="titulo">Union Logistic S.A.</h2>
                    <h3 className="subtitulo">Empresa dedicada al transporte de cargas generales, refrigeradas y congeladas</h3>
                    <a className="vermas" href="http://unionlogistic.com.ar/" target={'_blank'} rel={'noopener noreferrer'}>Más Información</a>
                </figcaption>
            </figure>
        </div>
    </section>
)

export default Trabajos;


